import { purchaseInit, purchaseClean } from '../../constants';

const init = {
};

export default (state = init, { type, payload }) => {
    switch(type) {
        case purchaseInit:
            return {
                ...state,
                ...payload.actions
            };
        case purchaseClean: 
            return init;
        default:
            return state;
    }
};